import CandidateQualification from './CandidateQualification.component';

export default CandidateQualification;